/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Title_Project_ExportInputs */

const en_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Export`)
};

const fr_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation du projet`)
};

const de_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt-Export`)
};

const it_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione del progetto`)
};

const ru_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт проекта`)
};

const es_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de proyectos`)
};

const zh_cn2_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目出口`)
};

const ja_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのエクスポート`)
};

const hi_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना निर्यात`)
};

const pt_pt2_ateliere_connect_title_project_export = /** @type {(inputs: Ateliere_Connect_Title_Project_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de Projetos`)
};

/**
* | output |
* | --- |
* | "Project Export" |
*
* @param {Ateliere_Connect_Title_Project_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_title_project_export = /** @type {((inputs?: Ateliere_Connect_Title_Project_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Title_Project_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_title_project_export(inputs)
	if (locale === "de") return de_ateliere_connect_title_project_export(inputs)
	if (locale === "it") return it_ateliere_connect_title_project_export(inputs)
	if (locale === "ru") return ru_ateliere_connect_title_project_export(inputs)
	if (locale === "es") return es_ateliere_connect_title_project_export(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_title_project_export(inputs)
	if (locale === "ja") return ja_ateliere_connect_title_project_export(inputs)
	if (locale === "hi") return hi_ateliere_connect_title_project_export(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_title_project_export(inputs)
	return en_ateliere_connect_title_project_export(inputs)
});